/**
 * The campaign tag vocabulary's typed edge (`api/src/socialsrc_api/schemas/tags.py`):
 * `TagValueOut`, `TagCategoryOut`, `TagVocabularyOut`. `icon` is a lucide name from
 * `../icons.tsx`, `null` inheriting; `locked` marks the alignment category and its four fixed
 * values; `alignment` is the key an alignment value counts as.
 */
import { z } from 'zod';

export const ALIGNMENT_KEYS = ['CAMPAIGN', 'ALLY', 'NEUTRAL', 'ADVERSARY'] as const;
export const alignmentKeySchema = z.enum(ALIGNMENT_KEYS);
export type AlignmentKey = z.infer<typeof alignmentKeySchema>;

export const ANALYSIS_SCOPES = ['ALL', 'RELATED'] as const;
export const analysisScopeSchema = z.enum(ANALYSIS_SCOPES);
export type AnalysisScope = z.infer<typeof analysisScopeSchema>;

export const tagValueSchema = z.object({
  id: z.string(),
  name: z.string(),
  active: z.boolean(),
  icon: z.string().nullish(),
  locked: z.boolean().default(false),
  alignment: alignmentKeySchema.nullish(),
  // Which posts of accounts carrying this alignment value are analysed; alignment values only.
  analysis_scope: analysisScopeSchema.nullish(),
  // The forbidden topic the name reads as recording about a person; advisory only.
  warning: z.string().nullish(),
});
export type TagValue = z.infer<typeof tagValueSchema>;

export const tagCategorySchema = z.object({
  id: z.string(),
  name: z.string(),
  active: z.boolean(),
  icon: z.string().nullish(),
  locked: z.boolean().default(false),
  // An account carries at most one of its values.
  single: z.boolean().optional(),
  warning: z.string().nullish(),
  accounts: z.number().int(),
  values: z.array(tagValueSchema),
});
export type TagCategory = z.infer<typeof tagCategorySchema>;

export const tagVocabularyResponseSchema = z.object({ categories: z.array(tagCategorySchema) });
